import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useThunk } from "../../hooks/useThunk";
import { createThread } from "../../store/thunks/threadThunks";
import { ErrorCodes } from "../../constants/errorCodes";
import CustomButton from "../Form/CustomButton";
import RenderImage from "../Common/RenderImage";
import TimeCalculator from "../../components/Common/TimeCalculator";
import showToast from "../../utils/toastNotifications";
import { formatYYYY_MM_DD } from "../../utils/dateFormating";

const ExploreJobCard = ({ job }) => {

  const navigate = useNavigate();
  const userState = useSelector(state => state?.auth?.user);

  // NOTE: defining thunks ======================================================================================
  const [doCreateThread, isCreateThread, errorCreateThread] = useThunk(createThread);

  // NOTE: function definitionmsa -==============================================================================

  // FUNCTION: handle card clisk
  const handleCardClick = () => {
    navigate(`/service-pro/tasker-feed/${job._id}`);
  };

  // FUNCTION: handle chat now button click
  const handleStartChat = async(user2Id) => {
    if(user2Id){
      const response = await doCreateThread(user2Id);
      if(response?.success){
        navigate(`/chat?thread=${response?.response?.data?._id}`)
      }else{
        if(response?.error?.customCode === ErrorCodes.DUPLICATE_ENTRIES.code){
          navigate(`/chat?thread=${response?.error?.message?.split(":")[1]?.toString()?.trim()}`)
        }else{
          showToast("error", response?.error?.message || "Error Occured");
        }
      }
    }else{
      showToast("error", "User ID Not Provided");
    }
  }

  return (
    <div
      className="flex flex-col  w-full cursor-pointer p-4 sm:p-6 bg-white hover:bg-lightyellow rounded-xl border border-light-blue hover:border-[#FBC948] md:flex-row md:items-stretch justify-between"
      onClick={handleCardClick}
    >
      <div className="w-full  md:w-[200px] h-[150px] md:h-[200px] md:flex-shrink-0 overflow-hidden rounded-[4px] mb-5 md:mb-0">
        <RenderImage
          src={job.images?.[0]}
          alt="Job"
          className="w-full h-full object-cover"
        />
      </div>

      {/*right side */}
      <div className="flex-1 flex flex-col justify-between md:pl-4">
        <div className="font-inter font-semibold sm:hidden block text-[#00796B] text-level-6 sm:text-level-[18px] leading-6">
          <TimeCalculator date={job.date} />
        </div>

        <div className="flex flex-row items-start justify-between mt-2 sm:mt-0">
          <div>
            <h2 className="text-[18px] sm:text-[20px] font-inter font-semibold text-dark leading-6 mb-1">
              {job.title}
            </h2>
            <p className="text-level-7 font-inter text-content leading-5">
              {job.location?.city}
            </p>
          </div>
          {/* posted time - desktop*/}
          <div className="hidden sm:block font-inter font-semibold text-level-6 sm:text-level-[18px] leading-6 text-nowrap text-[#00796B]">
            <TimeCalculator date={job.updatedAt} />
          </div>
        </div>

        {/* date, time */}
        <div className="mt-2 flex flex-row gap-16">
          <div className="flex flex-col">
            <h2 className="font-inter font-semibold text-level-6 leading-6 text-content">
              Date
            </h2>
            <time className="font-inter text-level-7 leading-6 text-content">
              {job.date ? formatYYYY_MM_DD(job.date) : "Date Not Available"}
            </time>
          </div>
          <div className="flex flex-col">
            <h2 className="font-inter font-semibold text-level-6 leading-6 text-content">
              Time
            </h2>
            <time className="font-inter text-level-7 leading-6 text-content">
              {job.time}
            </time>
          </div>
        </div>

        <div className="mt-2 md:mt-auto flex flex-col md:flex-row md:items-end md:justify-between">
          {/* category, skill */}
          <div className="mt-2 flex flex-wrap gap-2">
            <div>
              <h2 className="font-inter font-semibold text-level-6 leading-6 text-content mb-3">
                Category
              </h2>
              <span className="inline-block px-5 py-3 border bg-light rounded-[20px] text-level-7 font-inter text-content">
                {job.category?.categoryItem}
              </span>
            </div>
            <div>
              <h2 className="font-inter font-semibold text-level-6 leading-6 text-content mb-3">
                Skills
              </h2>
              <span className="inline-block px-5 py-3 bg-light rounded-[20px] border text-level-7 font-inter text-content">
                {job.category?.skills?.length > 0
                  ? job.category.skills.join(", ")
                  : "No Skills Specified"}
              </span>
            </div>
          </div>

          <div className="mt-5 w-full md:w-auto mx-auto md:mx-0 md:mt-0 md:ml-auto">
            <CustomButton
              className="bg-primary px-6 sm:px-[60px] py-4 font-inter font-semibold text-dark h-[49px] w-full md:max-w-[214px] rounded-xl hover:bg-opacity-90 transition-colors text-nowrap"
              loaderColor="white"
              loading={isCreateThread}
              buttonText="Chat Now"
              onClick={() => {handleStartChat(job?.createdBy?.toString())}}
              disabled={job?.createdBy?.toString() === userState?._id?.toString()}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExploreJobCard;
